import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/application`;

export const applicationService = {
    lookupApplication: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/lookup-application`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },
    createApplicationModule: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/module`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateApplicationModule: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/module`, params)
            .then((response) => {
                return response.data;
            });
    },
    deleteApplicationModule: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/module`, { params })
            .then((response) => {
                return response.data;
            });
    },
    getApplicationModule: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/module`, {
            params: { id: id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getApplicationModules: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/modules`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },
    createApplicationFeature: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/feature`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateApplicationFeature: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/feature`, params)
            .then((response) => {
                return response.data;
            });
    },
    deleteApplicationFeature: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/feature`, { params })
            .then((response) => {
                return response.data;
            });
    },
    getApplicationFeature: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/feature`, {
            params: { id: id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getApplicationFeatures: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/features`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    }, 
    createPermission: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/permission`, params)
            .then((response) => {
                return response.data;
            });
    },
    updatePermission: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/permission`, params)
            .then((response) => {
                return response.data;
            });
    },
    deletePermission: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/permission`, { params })
            .then((response) => {
                return response.data;
            });
    },
    getPermission: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/permission`, {
            params: { id: id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getPermissions: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/permissions`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },
    lookupPermission: async function (loadOptions:any) {
            const params = processLoadOptions(loadOptions);
            return axios.get(`${GATEWAY_URL}/lookup-permission`, {params})
            .then((response) => {
                return response.data;
            });
    },
    getPermissionValueTypes: async function (loadOptions:any) {
            const params = processLoadOptions(loadOptions);
            return axios.get(`${GATEWAY_URL}/permission-value-types`, {params})
            .then((response) => {
                return response.data;
            });
    },
};